/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_UpstreamInputs */



/**
* | output |
* | --- |
* | "The AI provider could not generate this response." |
*
* @param {Chat_Error_UpstreamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_upstream = /** @type {((inputs?: Chat_Error_UpstreamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_UpstreamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der KI-Anbieter konnte diese Antwort nicht erzeugen.")
	return /** @type {LocalizedString} */ ("The AI provider could not generate this response.")
});